import Section, {html, css} from './_section'

const HEARD_FROM = [
	'Coach',
	'Teammate',
	'Family',
	'Social Media',
	'Google',
	'Brochure',
	'Print Ad',
	'Email',
	'Oregon State Meet',
	'Other'
]

import {SHOE_SIZES, SHIRTS} from '../../ref'

customElements.define('steens-form-section-camper', class extends Section{

    get title(){ return this.model.isStaff ? 'Staff / Volunteer' : '⛺️ Camper' }

    // static get styles(){return css`
    //     :host {
    //         display: block;
    //         position:relative;
    //     }
    // `}

    static get listeners(){ return {
        model: {'change:dob change:session': 'update'}
    }}

    renderControls(){return html`

        <b-grid cols=2 cols-mobile=1>

            <form-control material="filled" key="name" label="Name">
                <text-field placeholder="First Last"></text-field>
                <!-- <input slot="control" type="text" autocomplete="section-camper name"> -->
            </form-control>

            <form-control material="filled" key="email" label="Email">
                <input slot="control" type="email" autocomplete="section-camper email">
            </form-control>

            <b-grid cols="${this.model.isStaff?1:'1,1,2'}">

                <form-control material="filled" label="Height" ?hidden=${this.model?.isStaff}>
                    <form-control slot="main" key="height_ft" style="margin: .75em;">
                        <text-field reset-invalid validate="int" placeholder="0"></text-field>

                        <span slot="suffix" style="pointer-events: none">&nbsp;ft&nbsp;</span>
                        <form-control slot="suffix" key="height_in" suffix=" in">
                            <text-field reset-invalid validate="int" placeholder="0"></text-field>
                        </form-control>
                    </form-control>
                </form-control>

                <form-control material="filled" key="weight" label="Weight" suffix=" lbs" style="min-width:96px" ?hidden=${this.model?.isStaff}>
                    <text-field slot="control" reset-invalid validate="int" placeholder="0"></text-field>
                </form-control>

                <form-control material="filled" label="Gender" key="gender">
                    <radio-group segment="theme">
                        <radio-btn value="f" label="Female"></radio-btn>
                        <radio-btn value="m" label="Male"></radio-btn>
                    </radio-group>
                </form-control>

            </b-grid>


            <form-control material="filled" key="dob" label="Birthday">
                <text-field reset-invalid type="date" no-datepicker></text-field>
            </form-control>

            <form-control material="filled" label="Grade" key="grade" ?hidden=${this.model?.isStaff}>
                <text-field placeholder="9" pattern="int" reset-invalid></text-field>
                <span slot="help">If going into college, put 13. Adult campers: enter graduation year</span>
            </form-control>

            <form-control material="filled" label="School" key="school">
                <text-field placeholder="School"></text-field>
                <span slot="help">
                    ${this.model.isStaff?html`
                        Do you coach or help at a school? Enter "n/a" if not.
                    `:html`
                        List the school for which you compete as of September 2021
                    `}</span>
            </form-control>

            <b-hr short style="margin: 0 auto"></b-hr>
            
            <section colspan>
                <div class="address">
                    
                    <form-control material="filled" key="address" label="Address">
                        <input slot="control" type="text" autocomplete="section-camper address-line1">
                    </form-control>
                    
                    <form-control material="filled" key="city" label="City">
                        <input slot="control" type="text" autocomplete="section-camper address-level2">
                    </form-control>
                    
                    <form-control material="filled" key="state" label="State">
                        <input slot="control" type="text" autocomplete="section-camper address-level1">
                    </form-control>
                    
                    <form-control material="filled" key="zip" label="Zip">
                        <input slot="control" autocomplete="section-camper postal-code">
                    </form-control>
                    
                    <form-control material="filled" key="phone" label="Phone">
                        <input slot="control" type="tel" autocomplete="section-camper tel">
                    </form-control>
                    
                </div>
            </section>		

            <b-hr short></b-hr>

            <b-grid cols=3 cols-mobile=1 colspan>

                <div>

                    <h4>Metadata</h4>

                ${this.model?.isStaff?html`
                <form-control key="returning_camper" prefix="Number of years at steens " suffix=" years">
                    <text-field pattern="int" placeholder="0"></text-field>
                </form-control>    
                `:html`
                <form-control key="returning_camper" prefix="This will be my " suffix=" year">
                    <select-field show-empty adjust-for-mobile="false">
                        <option value="">first</option>
                        <option value="2">second</option>
                        <option value="3">third</option>
                        <option value="4">fourth</option>
                        <option value="5">fifth</option>
                        <option value="6">sixth</option>
                        <option value="7">seventh</option>
                        <option value="8">eighth</option>
                    </select-field>
                    <div slot="label">Returning Camper?</div>
                </form-control>
                `}

                <form-control key="heard_from" prefix="How " style="margin-top: .5em">
                    <select-field adjust-for-mobile="true" placeholder="did you hear about us?" .options=${HEARD_FROM}></select-field>
                </form-control>

                </div>

                <div class="diet">
                    <h4>Diet</h4>
                    <check-box key="vegetarian" type="switch" placement="left" label="Request for vegetarian diet?"></check-box><br>

                    <check-box key="gluten_free" type="switch" placement="left" label="Request for gluten free diet?"></check-box><br><br>
                </div>


                <div class="nike">

                    <h4>Merch Sizes</h4>

                    <form-control prefix="Shirt: " key="shirt">
                        <select-field .options=${SHIRTS} placeholder="size" adjust-for-mobile="false"></select-field>
                    </form-control>

                    <form-control prefix="Shoe: " key="shoe" ?hidden=${!this.model?.isStaff}>
                        <select-field .options=${SHOE_SIZES} placeholder="size" search=false
                            adjust-for-mobile="false"
                            menu-max-height="200px"></select-field>
                    </form-control>

                </div>

                <form-control material="filled" key="coach" label="Coach's Name" ?hidden=${this.model?.isAdult}>
                    <text-field></text-field>
                </form-control>

                <form-control colspan material="filled" key="fav_memory" label="Favorite camp memory (optional)">
                    <text-field multiline></text-field>
                </form-control>
                
            </b-grid>
            
        </b-grid>
    `}

})